import React, { useState, useContext, useEffect } from 'react';
import { styled } from '@teko/ds-desktop';
import { DropdownContext } from './DropdownContext.es.js';

const DropdownToggle = ({
  children,
  className
}) => {
  const [anchor, setAnchor] = useState(null);
  const {
    state: { toggle, toggleType },
    dispatch
  } = useContext(DropdownContext);
  useEffect(() => {
    dispatch == null ? void 0 : dispatch({ type: "SET_REFERENCE", payload: anchor || void 0 });
  }, [anchor]);
  return /* @__PURE__ */ React.createElement(StyledDiv, {
    className,
    ref: setAnchor,
    onClick: toggleType === "click" ? toggle : void 0,
    onKeyUp: toggleType === "click" ? toggle : void 0,
    tabIndex: 0
  }, children);
};
const StyledDiv = styled.div`
  width: 100%;
  &:focus {
    outline: none;
  }
`;

export { DropdownToggle };
